/**
 * @desc: 工具- 虚拟键盘
 * @param  {[STRING]} related   [点击键盘时控制输入的INPUT DOM ID]
 * @param  {[bool]} display [是否展示]
 * @param  {[function]} closeFun [关闭软键盘的函数]
 * @author: Klaf
 * example:
 *   <VirtualKeyboard  related="keypad-trigger" display={this.state.display} closeFun={this.closeKeyboard} />
 */
import React from 'react';

export default class VirtualKeyboard extends React.Component {

  constructor(props) {
    super(props);
    // 键盘定位
    this.posLeft = '0px';
    this.posTop = '0px';
    //控制大小写
    this.isUpper = false;
    // 无用状态只为了触发组件update
    this.state = {
      random: Math.random(),
      opacity: 0,
      zindex: -1000
    }
  }

  // 第一次render前
  componentWillMount() {
    // 获取键盘布局
    this.getNumbersAndLetters(true);
  }

  // 第一次render后
  componentDidMount() {
    // 设置组件的绝对定位
    this.getKeyBoardAbsolutePositon();
    document.onclick = function (event) {
      if (event.target.className.indexOf('keypad-cannot-close-handle') > -1) {
        return;
      }
      this.props.closeFun();
    }.bind(this)
  }

  // 非初始化，从父级接收到prop改变时
  componentWillReceiveProps() {
    if (this.props.display == false) {
      // 获取键盘布局
      this.getNumbersAndLetters(true);
      // 更新组件的绝对定位
      this.getKeyBoardAbsolutePositon();
      this.showKey();
    } else {
      this.hideKey();
    }
  }

  // 被销毁时
  componentWillUnmount() {
    document.onclick = null;
  }

  // 展示键盘
  showKey() {
    this.setState({
      opacity: 1,
      zindex: 1000
    })
  }

  // 隐藏键盘
  hideKey() {
    this.setState({
      opacity: 0,
      zindex: -1000
    })
  }

  // 设置组件的绝对定位
  getKeyBoardAbsolutePositon() {
    var domid = this.props.related;
    var obj = document.getElementById(domid);
    if (!obj) return;
    var bounding = obj.getBoundingClientRect();

    var x = bounding.left - document.body.scrollLeft - 100;
    var y = bounding.top + document.body.scrollTop + 36;
    this.posLeft = x + 'px';
    this.posTop = y + 'px';
  }

  // 点击清空
  handleClear(related) {
    document.getElementById(related).value = '';
  }

  // 点击退格
  handleBackspace(related) {
    var old = document.getElementById(related).value;
    if (old.length > 0) {
      document.getElementById(related).value = old.substr(0, old.length - 1);
      return;
    }
  }

  // 点击键盘中的值
  handleInput(keyValue, related) {
    var old = document.getElementById(related).value;
    document.getElementById(related).value = old + keyValue;
  }

  // 点击大小写
  changeLetterCase() {
    this.isUpper = !this.isUpper;
    this.getNumbersAndLetters(false);
    this.setState({
      random: Math.random()
    })
  }

  // 递归函数，用于将数组中的元素打乱重组
  foreachGetNumber(arr, newArr) {
    if (arr.length > 0) {
      let r = parseInt(Math.random() * (arr.length));
      let num = arr[r];
      if (!newArr) {
        var newArr = [num];
      } else {
        newArr.push(num);
      }
      arr.splice(r, 1);
      return this.foreachGetNumber(arr, newArr);
    }
    return newArr || [];
  }

  // 获取打乱排序后的数字数组或字母数组
  getRandomSort(type) {
    // type 1 = number
    // type 2 = letters

    let numArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    let letterStr = 'abcdefghijklmnopqrstuvwxyz';

    // 数字
    if (type == 1) {
      return this.foreachGetNumber(numArr);
    }
    // 字母
    if (type == 2) {
      return this.foreachGetNumber(letterStr.split(''));
    }
  }

  // 重新获取键盘布局
  // sort是否打乱排序
  getNumbersAndLetters(sort) {
    // 开启打乱排序
    if (sort) {
      // 获取打乱顺序的数字和字母
      this.numArr = this.getRandomSort(1);

      // 26个字母分两行
      let tmpArr = this.getRandomSort(2);
      let str = tmpArr.join('');
      let str1 = str.substr(0, 13);
      let str2 = str.substr(13);

      this.letterArr1 = str1.split('');
      this.letterArr2 = str2.split('');
    }

    // 字母大小写转换
    if (this.isUpper) {
      _.times(this.letterArr1.length, function (i) {
        this.letterArr1[i] = this.letterArr1[i].toUpperCase();
        this.letterArr2[i] = this.letterArr2[i].toUpperCase();
      }.bind(this))
    } else {
      _.times(this.letterArr1.length, function (i) {
        this.letterArr1[i] = this.letterArr1[i].toLowerCase();
        this.letterArr2[i] = this.letterArr2[i].toLowerCase();
      }.bind(this))
    }
  }

  render() {
    const { related, display, closeFun } = this.props;
    let keyBoardStyle = { left: this.posLeft, top: this.posTop }
    if (display) {
      keyBoardStyle.opacity = 1;
      keyBoardStyle.zIndex = 1000;
    } else {
      keyBoardStyle.opacity = 0;
      keyBoardStyle.zIndex = -1000;
    }
    // 数字模板
    var numbersList = this.numArr.map((row, index) => {
      return (
        <button type="button" className="keypad-key keypad-cannot-close-handle" key={index} onClick={this.handleInput.bind(this, row, related)}>{row}</button>
      )
    })
    // 字母1模板
    var lettersList1 = this.letterArr1.map((row, index) => {
      return (
        <button type="button" className="keypad-key keypad-cannot-close-handle" key={index} onClick={this.handleInput.bind(this, row, related)}>{row}</button>
      )
    })
    // 字母2模板
    var lettersList2 = this.letterArr2.map((row, index) => {
      return (
        <button type="button" className="keypad-key keypad-cannot-close-handle" key={index} onClick={this.handleInput.bind(this, row, related)}>{row}</button>
      )
    })

    return (
      <div className='virtual-keyboard-layout keypad-cannot-close-handle' style={keyBoardStyle}>
        <div className="keypad-row keypad-cannot-close-handle">
          <div className="keypad-space keypad-cannot-close-handle"></div>
          <div className="keypad-space keypad-cannot-close-handle"></div>
          <div className="keypad-space keypad-cannot-close-handle"></div>
          {numbersList}
        </div>
        <div className="keypad-row keypad-cannot-close-handle">
          {lettersList1}
        </div>
        <div className="keypad-row keypad-cannot-close-handle">
          {lettersList2}
        </div>
        <div className="keypad-row keypad-cannot-close-handle">
          <div className="keypad-space keypad-cannot-close-handle"></div>
          <div className="keypad-space keypad-cannot-close-handle"></div>
          <button type="button" className="keypad-key keypad-shift keypad-cannot-close-handle" title="转换字母大小写" onClick={this.changeLetterCase.bind(this)}>大小写</button>
          <button type="button" className="keypad-key keypad-clear keypad-cannot-close-handle" title="点击清空" onClick={this.handleClear.bind(this, related)}>清空</button>
          <button type="button" className="keypad-key keypad-back keypad-cannot-close-handle" title="退格" onClick={this.handleBackspace.bind(this, related)}>退格</button>
          <button type="button" className="keypad-key keypad-close keypad-cannot-close-handle" title="关闭软键盘" onClick={closeFun.bind(this, false)}>关闭</button>
        </div>
        <div className="cf"></div>
      </div>
    );
  }
}
